import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote: "This is a very good business plan. I'll let my boss know and I'll let you know if they are interested.",
    author: "Real Estate Agent",
    location: "Abuja",
  },
  {
    quote: "This is good.",
    author: "Saminaka",
    role: "Property Consultant",
  },
  {
    quote: "Good morning sir, that's a good product, congratulations. I will speak to him and let you know but it's a great product.",
    author: "Yasin",
    role: "Elite Cycle Homes Network",
  },
];

export const Testimonials = () => {
  return (
    <section className="section-padding bg-foreground text-background">
      <div className="container-tight">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-secondary font-semibold text-sm uppercase tracking-wider"
          >
            Social Proof
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-display text-3xl sm:text-4xl font-bold text-background mt-2"
          >
            What Real Estate Professionals Say
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass rounded-2xl p-6 border border-background/10"
            >
              <Quote className="w-8 h-8 text-secondary/60 mb-4" />
              <p className="text-background/90 leading-relaxed mb-6 italic">
                "{t.quote}"
              </p>
              <div className="border-t border-background/10 pt-4">
                <p className="font-semibold text-background text-sm">{t.author}</p>
                <p className="text-background/50 text-xs">
                  {t.role ? t.role : t.location}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
